import getBit from './get-bit';
import setBit from './set-bit';
import toggleBit from './toggle-bit';
export { getBit, setBit, toggleBit };
export default { getBit: getBit, setBit: setBit, toggleBit: toggleBit };
